import Section from './SectionStyles';

const Index = ({ children }) => {
  return <Section>{children}</Section>;
};

export default Index;
